var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetailer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.5H28.75V10H27.5V23.75H28.75V26.25H1.25V23.75H2.5V10H1.25V7.5H5V5C5 4.66848 5.1317 4.35054 5.36612 4.11612C5.60054 3.8817 5.91848 3.75 6.25 3.75H23.75C24.0815 3.75 24.3995 3.8817 24.6339 4.11612C24.8683 4.35054 25 4.66848 25 5V7.5ZM25 10H5V23.75H8.75V15H11.25V23.75H13.75V15H16.25V23.75H18.75V15H21.25V23.75H25V10ZM7.5 6.25V7.5H22.5V6.25H7.5Z",
    fill: "#0388D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailer);
export default __webpack_public_path__ + "static/media/retailer.e3cad9caca368e16753633d03b6e8aac.svg";
export { ForwardRef as ReactComponent };